module.exports = __webpack_public_path__ + "img/shili_brandAddNew.c3f1872b.png";